import { inject, Service } from '@angular/core';

import type { BaasMeldingPayload } from '@lvflanders/bar';
import { BaasAppState, BaasMeldingService } from '@lvflanders/bar';

import { BAR_CORE_CONSTANTS } from '../constants/bar-core.constants';
import { BarMelding, toBarMelding } from '../models/bar-melding';
import { BarMeldingType } from '../models/bar-melding-type.enum';
import { _BarCoreStateService } from '../services/baas-core-state.service';

@Service({ autoProvided: false })
export class BarMeldingenEngine {
    readonly #state = inject(BaasAppState);
    readonly #coreState = inject(_BarCoreStateService);
    readonly #meldingService = inject(BaasMeldingService);

    /** Retrieves and processes the meldinen. Returns true in case the route is available (meaning no blocking meldingen). */
    async retrieveAndProcess(routeUrl: string): Promise<boolean> {
        const pathnameEndsWithSlash = this.#state.location.app.pathname.endsWith('/');
        const url = `${this.#state.location.app.pathname}${pathnameEndsWithSlash ? routeUrl.substring(1) : routeUrl}`;
        let meldingen: BaasMeldingPayload[];
        try {
            meldingen = await this.#meldingService.getMeldingen(url);
        } catch {
            meldingen = [];
        }
        let onbeschikbaarMelding: BarMelding = null;
        if (meldingen && meldingen.length) {
            // Parse DTO to our model
            const parsedMeldingen: BarMelding[] = meldingen.map((m) => toBarMelding(m));
            // Find melding of type onbeschikbaar
            onbeschikbaarMelding = parsedMeldingen.find((m: BarMelding) => m.meldingType === BarMeldingType.Onbeschikbaar);
            // If melding of type onbeschikbaar has been found, redirect to onbeschikbaar page
            if (onbeschikbaarMelding) {
                this.#handleOnbeschikbaar(onbeschikbaarMelding);
            } else {
                // Set meldingen on layout
                this.#coreState.meldingen.set(parsedMeldingen);
            }
        } else {
            this.#coreState.meldingen.set([]);
        }

        return onbeschikbaarMelding == null;
    }

    #handleOnbeschikbaar(melding: BarMelding): void {
        const meldingKey = `${BAR_CORE_CONSTANTS.STORAGE_KEY_PREFIX}melding_${melding.id}`;
        // store melding content in session storage
        window.sessionStorage.setItem(meldingKey, JSON.stringify(melding));
        // redirect to onbeschikbaar pagina which will ready the melding to show from the session storage (and clean it up)
        window.location.href = `${this.#state.location.baasStatic.url}${BAR_CORE_CONSTANTS.PAGES.ONBESCHIKBAAR}/${melding.id}`;
    }
}
